import React from 'react'
import { Box, Grid } from '@mui/material'
import CustomBadge from './CustomBadge'
import TagBadge from './TagBadge'
import { badgeColors } from '../Color/Color'

// BadgePanel component
const BadgePanel: React.FC = () => {
  return (
    <Box sx={{ padding: 2 }}>
      <h2>Custom Badge Styles</h2>

      {/* Custom Badge Section */}
      <Grid container spacing={2} direction='row'>
        {Object.entries(badgeColors).map(([label, color], index) => (
          <Grid key={index}>
            <CustomBadge label={label} color={color} />
          </Grid>
        ))}
      </Grid>

      <h2>Custom Tag Badge Styles</h2>

      {/* Tag Badge Section */}
      <Grid container spacing={2} direction='row'>
        {Object.entries(badgeColors).map(([label, color], index) => (
          <Grid key={index}>
            <TagBadge label={label} color={color} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default BadgePanel
